<bl-modal-content #content
  [title]="headerTitle">
  <div body class="main-body">
    <table class="table table-bordered" border="2">
      <tr class="header first">
        <td class="title" colspan="2">コンタクトカレンダーの初期表示を設定してください。</td>
      </tr>
      <tr>
        <th class="header-width">
          <span>実施内容</span>
        </th>
        <td>
          <div class="item_check_group_div">
            <bl-checkbox-group
              [values]="contactInitDisplaySettingDtlCalendar.contactCheckDivList"
              [items]="contactCheckDivArray"
              [option]="{'labelProperty': 'name','valueProperty': 'code'}"
              [groupType]="'inline'"
              (changeEvent)="onChangeCalendarContactCheckDivArray($event)"
            ></bl-checkbox-group>
            <div class="multi_select">
              <bl-multi-select
                [values]="contactInitDisplaySettingDtlCalendar.contactExecuteItemCodeList"
                [items]="contactImplDivArray"
                [option]="{labelProperty: 'name', valueProperty: 'code'}"
                (changeEvent)="onChangeCalendarContactImplDiv($event)"
              ></bl-multi-select>
            </div>
          </div>
        </td>
      </tr>
      <tr>
        <th class="header-width">
          <span>組織</span>
          <span class="label-tag-required"></span>
        </th>
        <td>
          <div class="half_length">
            <share-organization-combo-box
              [withAllCompanyDiv]="WithAllCompanyDiv.None"
              [(value)]="contactInitDisplaySettingDtlCalendar.organizationCode"
              [officeControl]="false"
            ></share-organization-combo-box>
          </div>
        </td>
      </tr>
      <tr>
        <th class="header-width">
          <span>担当者</span>
        </th>
        <td>
          <div class="item_check_div">
            <div>
              <bl-checkbox
                [label]="'ログイン担当者を使用する'"
                [checked]="isUseLoginPicFlgCalendar === true"
                (changeEvent)="onChangeEmployeeFlg($event.target.checked, 'calendar')"
              ></bl-checkbox>
            </div>
            <div class="input-group form-size--l">
              <bl-text-input
                [(value)]="calendarPicName"
                [maxlength]="60"
                [disabled]="employeeDisableFlgCalendar"
                [placeholder]="'従業員コード'"
                (changeEvent)="changePicCode('calendar', $event)"
              ></bl-text-input>
              <span class="input-group-btn">
                <button
                  #employeeGuideButton
                  class="btn btn-default" type="button"
                  [disabled]="employeeDisableFlgCalendar"
                  (click)="onClickEmployeeGuide('calendar', employeeGuideButton)">
                  <span class="icon-icon_guide glyphicon"></span>
                </button>
              </span>
            </div>
          </div>
        </td>
      </tr>
      <tr class="header second">
        <td class="title" colspan="2">コンタクト一覧の初期表示を設定してください。</td>
      </tr>
      <tr>
        <th class="header-width">
          <span>実施内容</span>
        </th>
        <td>
          <div class="item_check_group_div">
            <bl-checkbox-group
              [values]="contactInitDisplaySettingDtlGrid.contactCheckDivList"
              [items]="contactCheckDivArray"
              [option]="{'labelProperty': 'name','valueProperty': 'code'}"
              [groupType]="'inline'"
              (changeEvent)="onChangeGridContactCheckDivArray($event)"
            ></bl-checkbox-group>
            <div class="multi_select">
              <bl-multi-select
                [values]="contactInitDisplaySettingDtlGrid.contactExecuteItemCodeList"
                [items]="contactImplDivArray"
                [option]="{labelProperty: 'name', valueProperty: 'code'}"
                (changeEvent)="onChangeGridContactImplDiv($event)"
              ></bl-multi-select>
            </div>
          </div>
        </td>
      </tr>
      <tr>
        <th class="header-width">
          <span>対象期間(実施予定日)</span>
          <span class="label-tag-required"></span>
        </th>
        <td>
          <div class="item_check_div">
            <div class="apply_select_fst">
              <!-- 適用開始期間基準区分 -->
              <bl-select
                [(value)]="contactInitDisplaySettingDtlGrid.applyStartPeriodCriteriaDiv"
                [items]="applyPeriodCriteriaDivItems"
              ></bl-select>
            </div>
            <div class="apply_number_length">
              <bl-number-input
                [(value)]="contactInitDisplaySettingDtlGrid.applyStartNum"
                [option]="{ minus: false, min: 0, max: 99 }"
                [disabled]="isApplyStartPeriodToday"
              ></bl-number-input>
            </div>
            <div class="apply_select_lst">
              <!-- 月週日区分 -->
              <bl-select
                [(value)]="contactInitDisplaySettingDtlGrid.monthWeekDayDiv"
                [items]="monthWeekDayDivItems"
                [disabled]="isApplyStartPeriodToday"
              ></bl-select>
            </div>
            <span class="from_to">～</span>
            <div class="apply_select_fst">
              <!-- 適用終了期間基準区分 -->
              <bl-select
                [(value)]="contactInitDisplaySettingDtlGrid.applyEndPeriodCriteriaDiv"
                [items]="applyPeriodCriteriaDivItems"
              ></bl-select>
            </div>
            <div class="apply_number_length">
              <bl-number-input
                [(value)]="contactInitDisplaySettingDtlGrid.applyEndNum"
                [option]="{ minus: false, min: 0, max: 99 }"
                [disabled]="isApplyEndPeriodToday"
              ></bl-number-input>
            </div>
            <div class="apply_select_lst">
              <!-- 月週日区分 -->
              <bl-select
                [(value)]="contactInitDisplaySettingDtlGrid.monthWeekDayDiv"
                [items]="monthWeekDayDivItems"
                [disabled]="isApplyEndPeriodToday"
              ></bl-select>
            </div>
          </div>
        </td>
      </tr>
      <tr>
        <th class="header-width">
          <span>組織</span>
          <span class="label-tag-required"></span>
        </th>
        <td>
          <div class="half_length">
            <share-organization-combo-box
              [withAllCompanyDiv]="WithAllCompanyDiv.None"
              [(value)]="contactInitDisplaySettingDtlGrid.organizationCode"
              [officeControl]="false"
            ></share-organization-combo-box>
          </div>
        </td>
      </tr>
      <tr>
        <th class="header-width">
          <span>担当者</span>
        </th>
        <td>
          <div class="item_check_div">
            <div>
              <bl-checkbox
                [label]="'ログイン担当者を使用する'"
                [checked]="isUseLoginPicFlgGrid === true"
                (changeEvent)="onChangeEmployeeFlg($event.target.checked, 'contactList')"
              ></bl-checkbox>
            </div>
            <div class="input-group form-size--l">
              <bl-text-input
                [value]="contactListPicName"
                [option]="{ maxLength: 60 }"
                [disabled]="employeeDisableFlgContactList"
                [placeholder]="'従業員コード'"
                (changeEvent)="changePicCode('contactList', $event)"
              ></bl-text-input>
              <span class="input-group-btn">
                <button
                  #employeeGuideButton
                  class="btn btn-default" type="button"
                  [disabled]="employeeDisableFlgContactList"
                  (click)="onClickEmployeeGuide('contactList', employeeGuideButton)">
                  <span class="icon-icon_guide glyphicon"></span>
                </button>
              </span>
            </div>
          </div>
        </td>
      </tr>
    </table>
  </div>
</bl-modal-content>



// WEBPACK FOOTER //
// ./src/app/feature/contact-init-setting/contact-init-setting-modal.component.html